import { render, staticRenderFns } from "./Time.vue?vue&type=template&id=3865fa38&"
import script from "./Time.vue?vue&type=script&lang=js&"
export * from "./Time.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports